import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ReactTabs.module.css';

/**
 * ReactTabs
 * @type React.FC<ReactTabsPropTypes>
 */
const ReactTabs = React.forwardRef((props, ref) => {
  Object.keys(props).forEach((p) => {
    if (!Object.keys(ReactTabsPropTypes).includes(p)) {
      console.error(`ReactTabs: 정의되지 않은 prop ${p}가 전달되었습니다.`);
    }
  });

  const refTabPanel = useRef();

  /** 외부에서 접근할 수 있는 함수들 */
  React.useImperativeHandle(ref, () => ({
    setSelectedIndex(index) {
      setCurrState((prev) => ({
        ...prev,
        selectedIndex: index,
      }));
    },

    getSelectIndex() {
      return currState.selectedIndex;
    },
  }));

  const [currState, setCurrState] = useState({
    tabs: props.tabs,
    selectedIndex: props.selectedIndex ?? 0,
    forceRender: props.forceRender ?? true,
    focusTab: props.focusTab,
  });

  const selectedIndexChanged = (idx) => {
    setCurrState((prev) => ({
      ...prev,
      selectedIndex: idx,
    }));
  };

  const _onSelect = (idx, lastIdx, e) => {
    selectedIndexChanged(idx);
    if (props.onSelect) props.onSelect(idx, lastIdx, e);
  };

  const _init = (e) => {
    refTabPanel.current = e;
  };

  return currState.tabs?.length ? (
    <div>
      <Tabs
        domRef={_init}
        onSelect={_onSelect}
        forceRenderTabPanel={currState.forceRender}
        selectedIndex={currState.selectedIndex}
        className={styles.tabsBelow}
        focusTabOnClick={currState.focusTab}
      >
        <TabList>
          {currState.tabs?.map((item, idx) => {
            return (
              <Tab
                key={
                  Math.random()
                    .toString(36)
                    .replace(/[^a-z]+/g, '')
                    .substr(0, 5) +
                  `_` +
                  idx
                }
              >
                {item.header}
              </Tab>
            );
          })}
        </TabList>

        {currState.tabs?.map((item, idx) => {
          return <TabPanel key={`tabPanel_ + ${idx}`}>{item.content}</TabPanel>;
        })}
      </Tabs>
    </div>
  ) : null;
});

const ReactTabsPropTypes = {
  tabs: PropTypes.array,
  selectedIndex: PropTypes.number,
  forceRender: PropTypes.bool,
  onSelect: PropTypes.func,
  focusTab: PropTypes.bool,
};
ReactTabs.propTypes = ReactTabsPropTypes;
ReactTabs.defaultProps = {
  tabs: [],
  selectedIndex: 0,
  forceRender: true,
  onSelect: null,
  focusTab: false,
};
ReactTabs.displayName = 'ReactTabs';

export default ReactTabs;
